import { overrideSVGColor } from '@23degrees/shared/manager/chart/chart.utils';
import { FieldTypes, getOldFields, OldFields } from './content';
import { InlineValue } from './InlineValue';

interface DeltaInsertOp {
  insert: any;
  attributes: any;
}

export class InlineMedia extends InlineValue {
  static create = (deltaOp: DeltaInsertOp) => {
    return new InlineMedia(deltaOp);
  };

  public resolveFieldsReference = (dataContext: any, fallbackStr = 'No data available', content?: any) => {
    const options = this.deltaOp.insert.value;
    this.fieldName = options.fieldName;
    return this.resolveFields(dataContext, fallbackStr);
  };

  public getHTML = (value: string, escapeMediaLink: (link: string) => string, imageFormat?: Record<string, string | number> | null, attributes?: Record<string, string>) => {
    if (!value) return '';

    let imgClasses: string[] = ['object-contain', 'inline'];
    let svgClasses: string[] = [];

    let styles = [];
    if (imageFormat?.radius) styles.push(`border-radius:${imageFormat.radius}%`);
    if (imageFormat?.maxHeight) styles.push(`height: ${imageFormat.maxHeight}px`);
    if (imageFormat?.maxWidth) styles.push(`width:${imageFormat.maxWidth}px`);

    let mediaHTML = '';
    if (value.startsWith('media:')) {
      const url = value.split('media:');
      let mediaURL = `${escapeMediaLink(url[1])}`;

      // in case of svgs, assing other atts (color)
      if (attributes?.color) mediaURL = overrideSVGColor(mediaURL, attributes?.color);

      mediaHTML = `<img class="${imgClasses.join(' ')}" style="${styles.join(';')}" src="${mediaURL}"/>`;
    }
    // External URL
    if (value.startsWith('http://') || value.startsWith('https://')) {
      mediaHTML = `<img class="${imgClasses.join(' ')}" style="${styles.join(';')}" src="${value}" />`;
    }
    // Local icons reference (like slack :col, :ita, etc)
    if (value.startsWith('flag:')) {
      const flag = value.split('flag:');
      mediaHTML = `<span class="fi fi-${flag[1]} ${svgClasses.join(' ')}" style="${styles.join(';')}"></span>`;
    }

    if (value.startsWith('icon:')) {
      const icon = value.split('icon:');
      mediaHTML = `<span class="ico ico-${icon[1]} ${svgClasses.join(' ')}" style="${styles.join(';')}"></span>`;
    }
    return mediaHTML;
  };
}